<script lang="ts">
    import MedialibFile from "../../MedialibFile.svelte"
    import MedialibImage from "../../MedialibImage.svelte"

    export let column: BlockColumn<"image">
</script>

<MedialibFile id="{column.image}" let:entry let:src>
    {#if entry.file?.type?.startsWith("video")}
        <video controls muted autoplay>
            <source {src} type="video/mp4" />
            Your browser does not support the video tag.
        </video>
    {:else}
        <div class="background-image">
            <figure>
                <MedialibImage id="{column.image}" />
            </figure>
        </div>
    {/if}
</MedialibFile>

<style>
    figure {
        margin: 0px;
    }
</style>
